<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs" classes="modal fade show" content-class="modal-dialog" :click-to-close="false">
		<form class="modal-content" role="form" @submit.prevent="onMoveFromArchive(close)">
			<div class="modal-header bg-info text-white py-2">
				<h1 class="modal-title fs-5">{{$t('header.exams-move-from-archive')}}</h1>
				<button type="button" class="btn-close" @click="$emit('cancel', close)" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="alert alert-info">
					<div>{{$t('text.selected')}}: {{ids.length}}</div>
				</div>
				<div>{{$t('text.confirm-exams-move-from-archive')}}</div>
				<div class="m-t"><span style="color: #900;">{{$t('text.attention')}}</span> {{$t('text.warning.exams-move-from-archive')}}</div>
				<div class="alert alert-warning alert-dismissible fade show mt-2 mb-0" v-if="error">
					{{error}}
					<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
				</div>
			</div>
			<div class="modal-footer p-1">
				<button type="submit" class="btn btn-info" :disabled="loading">{{$t('btn.move-from-archive')}}</button>
				<button type="button" class="btn btn-outline-secondary" @click="$emit('cancel', close)">{{$t('btn.cancel')}}</button>
			</div>
		</form>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	inheritAttrs: false,
	//emits: ['confirm', 'cancel']
	data: () => ({
		ids: [],
		
		error: '',
		loading: false,
	}),
	methods: {
		async onMoveFromArchive(close){
			this.loading = true;
			this.error = '';
			let ret = await this.appModel.doMoveExamsFromArchive(this.$vfm.modals[0].params._value.ids);
			if(ret.success){
				this.$emit('moveFromArchiveMulti', close);
			} else {
				this.error = ret.message;
			}
			this.loading = false;
		},
	},
	mounted(){
		this.ids = this.$vfm.modals[0].params._value.ids;
	},
}
</script>